import DontHaveFiles from './dontHaveFiles';

export default DontHaveFiles;
